import React, { useState } from "react";
import { jsPDF } from "jspdf";

const RoadManagement = () => {
  const [roadName, setRoadName] = useState("");
  const [roadSearch, setRoadSearch] = useState("");
  const [roads, setRoads] = useState([]);

  const addRoad = () => {
    if (!roadName.trim()) {
      alert("रोड / गल्ली नाव भरा");
      return;
    }
    setRoads([...roads, { id: Date.now(), name: roadName }]);
    setRoadName("");
  };

  const deleteRoad = (id) => {
    setRoads(roads.filter((r) => r.id !== id));
  };

  const generatePDF = async (specificId = null) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      
      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("रोड / गल्ली व्यवस्थापन", pageWidth / 2, 10, { align: "center" });
      
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);
      
      const exportData = specificId 
        ? roads.filter(item => item.id === specificId)
        : roads;
      
      const tableData = exportData.map((item, index) => [
        index + 1,
        item.name
      ]);
      
      pdf.autoTable({
        head: [["अ.क्र.", "रोड / गल्ली नाव"]],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold",
          fontSize: 11
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 10
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        }
      });
      
      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(`पृष्ठ ${i} / ${pageCount}`, pageWidth / 2, pdf.internal.pageSize.getHeight() - 10, { align: "center" });
      }
      
      const fileName = specificId ? `रोड-${specificId}.pdf` : `रोड-यादी.pdf`;
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  const filteredRoads = roads.filter((r) =>
    r.name.toLowerCase().includes(roadSearch.toLowerCase())
  );

  return (
    <div className="card-box mt-4">
      <div className="title">रोड / गल्लीची यादी</div>

      {/* Add Road */}
      <div className="row align-items-end mb-3">
        <div className="col-md-4">
          <label className="form-label fw-semibold">रोड / गल्ली नाव</label>
          <input
            type="text"
            className="form-control"
            value={roadName}
            onChange={(e) => setRoadName(e.target.value)}
            placeholder="उदा. 6 NEAR TMP"
          />
        </div>

        <div className="col-md-3 mt-3 mt-md-0">
          <button className="add-btn w-100" onClick={addRoad}>
            नवीन रोड / गल्ली जोडा
          </button>
        </div>
      </div>

      {/* Search + Count */}
      <div className="row align-items-end mb-3">
        <div className="col-md-4">
          <label className="form-label fw-semibold">रोड / गल्ली शोधा</label>
          <input
            type="text"
            className="form-control"
            value={roadSearch}
            onChange={(e) => setRoadSearch(e.target.value)}
            placeholder="शोधा"
          />
        </div>

        <div className="col-md-3">
          <div className="count-box">
            एकूण रोड / गल्ली <br />
            <span>{filteredRoads.length}</span>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card-box">
        <div className="table-header">
          <h3>रोड / गल्ली यादी</h3>
          <div className="pdf-buttons">
            <button className="btn-pdf-all" onClick={() => generatePDF()}>
              📄 सर्व PDF
            </button>
          </div>
        </div>
        <table className="table table-bordered m-0">
        <thead>
          <tr>
            <th>रोड / गल्ली नाव</th>
            <th style={{ width: "120px" }}>क्रिया</th>
          </tr>
        </thead>
        <tbody>
          {filteredRoads.length === 0 ? (
            <tr>
              <td colSpan="2" className="text-center text-muted p-3">
                माहिती सापडली नाही
              </td>
            </tr>
          ) : (
            filteredRoads.map((road) => (
              <tr key={road.id}>
                <td>{road.name}</td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => deleteRoad(road.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoadManagement;
